import { PlusOutlined } from '@ant-design/icons';
import {
  App, Button, Table,
} from 'antd';
import EmptyComponent from 'components/Empty';
import React from 'react';
import { captureException } from 'utils/errors';
import { EventEmitter } from 'utils/event';
import http, { getHttpErrorMessage } from 'utils/http';
import columns from './columns';

function List({
  organizationId,
  ingredients,
  loading,
  searchTerm,
  categoryFilter,
  page,
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange,
  onCreate,
  onEdit,
}) {
  const { message, modal } = App.useApp();

  const onDelete = (ingredient) => {
    modal.confirm({
      title: 'Delete ingredient?',
      content: 'This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await http.delete(`v1/organizations/${organizationId}/ingredients/${ingredient.id}/`);
          message.success('Ingredient deleted successfully');
          EventEmitter.emit('refresh_ingredients');
        } catch (error) {
          captureException(error);
          message.error(getHttpErrorMessage(error));
        }
      },
    });
  };

  if (!loading && !ingredients.length && !searchTerm && categoryFilter === 'all') {
    return (
      <EmptyComponent
        title="Start by adding your first ingredient."
        primaryAction={(
          <Button icon={<PlusOutlined />} onClick={onCreate} type="primary">
            Add ingredient
          </Button>
        )}
      />
    );
  }

  return (
    <Table
      columns={columns({ onEdit, onDelete })}
      dataSource={ingredients}
      loading={loading}
      scroll={{ x: 760 }}
      pagination={{
        current: page,
        pageSize,
        total: totalCount,
        showSizeChanger: true,
        pageSizeOptions: [25, 50, 100],
        showTotal: (total) => `Total ${total} results`,
        onChange: (nextPage, nextPageSize) => {
          if (nextPageSize !== pageSize) {
            onPageSizeChange(nextPageSize);
            return;
          }
          onPageChange(nextPage);
        },
      }}
      rowClassName="cursor-pointer"
    />
  );
}

export default List;
